import "./global.css";

import 'react-toastify/dist/ReactToastify.css';
import { useScrollToTop } from "./hooks/use-scroll-to-top";
import ThemeProvider from "./theme";
import Router from "./routes/sections";
import { AuthProvider } from "./providers/AuthProvider";

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router />
      </AuthProvider>
    </ThemeProvider>
  );
}
